<app-loader *ngIf="isDisabled"></app-loader>
<form name="DesignationSummaryForm" (ngSubmit)="Validate(DesignationSummaryForm)" #DesignationSummaryForm="ngForm">
    <div class="card border-radius-0 m-0 p-0">
        <div class="card-header">
            <label>Designation Summary<span class="fw-bold">({{this.SiteName}})</span></label>
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="designationWiseSummaryEditdata"
                class="customeDatatable table table-bordered" name="designationWiseSummaryEditdata"
                style="font-size: xx-small !important">
            </table>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="close()"
                        [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button type="submit" class="btn btn-sm btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>